'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-279/node_modules/@eliadmin/core/src/components/pharmacy/prescription-reservation-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-279/node_modules/@eliadmin/core/src/components/pharmacy/prescription-reservation-form.tsx").PrescriptionReservationForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/prescriptionReservationForm").then(m => ({ default: m.PrescriptionReservationForm })));
export function PrescriptionReservationForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

